import React from 'react';
import queryString from 'query-string';
import Lightbox from 'react-images';
import { Field,reduxForm,formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import renderCheckbox from '../../components/MaterialUi/renderCheckbox';
import RFNativeSelectField from '../../components/ReduxFormComps/RFNativeSelectField';
import * as actions from '../../redux/imgSegment/actions';
import ContainerRowSpace from '../../components/common/ContainerRowSpace'
import ContainerRowTitle from '../../components/common/ContainerRowTitle'
import ContainerRowError from '../../components/common/ContainerRowError'
import ImageCateDicts from './ImageCateDicts'

const closeLightbox=(props)=>{
    props.closeLightBox();
}

const imageBoxOnClick=(props)=>{
    props.openLightBox();
}

const renderSubmitButton = (props,pristine,submitting) => {
    let { answerImgObjNa,answerImgNotLoad,answerTotalObjDetected } = props;
   
    if (answerTotalObjDetected || answerImgObjNa||answerImgNotLoad){
        return (
            <div className="d-flex flex-row"> 
                <div className="p-2">
                    <button className="btn btn-primary btn-lg" type="submit" disabled={submitting}>
                    Submit Your Answer
                    </button>
                </div>
            </div>
        );
    }
}  

const encodeImageUrl=(imgUrl,imgId)=>{
    let arrImgUrl=imgUrl.split('/');
    arrImgUrl.splice(arrImgUrl.length - 1, 1);//Remove last element
    let newImgUrl=arrImgUrl.join('/');
    let encodeImgId=imgId;
    encodeImgId=decodeURIComponent(imgId);
    encodeImgId=encodeURIComponent(imgId);

    newImgUrl=`${newImgUrl}/${encodeImgId}`;
    return newImgUrl;
}

export class ImageSegmentQuestion extends React.Component {
    
    componentWillMount(){
        const { location } = this.props;
        const query = queryString.parse(location.search);
        const { jwt, taskAcceptedInfoId } = query;
        this.props.updateQuery(query);
    }
    
    componentDidUpdate(){
        const { imgSegment } = this.props;
        const { query,task,imgSegmentQuestion,taskAccessKey } = imgSegment;

        if (!task && query && query.jwt && query.taskAcceptedInfoId){
            this.props.getTaskConfig(query.jwt,query.taskAcceptedInfoId);
        }
        
        if (!imgSegmentQuestion && query && query.jwt && taskAccessKey){
            this.props.getCurrentSegmentQuestion(query.jwt,taskAccessKey);
        }
    }

    answerTotalObjDetectedOnChange(e){
        let imgSegmentForm={};
        imgSegmentForm.answerTotalObjDetected=e.target.value;
        this.props.updateAnswer(imgSegmentForm);
    }    

    answerImgObjNaOnChange(e) {
        let imgSegmentForm={};
        imgSegmentForm.answerImgObjNa=e.target.checked;
        this.props.updateAnswer(imgSegmentForm);
    }
    
    answerImgNotLoadOnChange(e){
        let imgSegmentForm={};
        imgSegmentForm.answerImgNotLoad=e.target.checked;
        this.props.updateAnswer(imgSegmentForm);
    }
    
    render(){
        const { location,handleSubmit,answerImgObjNa,answerImgNotLoad,pristine,submitting,initialValues,imgSegment } = this.props;
        const query = queryString.parse(location.search);
        const { task } = imgSegment
        const taskTitle=task?task.task_name: 'Image Segmentation Question';
        
        if (imgSegment.taskCompleted===true) {
            return <Redirect to="/imageSegmentAckTaskEnd"/>;
        }
    
        if (imgSegment.taskContinue===true){
            return <Redirect to="/imageSegmentAckTaskContinue"/>;
        }

        if (!query.jwt || !query.imgUrl || !query.taskAcceptedInfoId) {
            return (
                <div className="container">
                   <ContainerRowSpace />
                   <ContainerRowTitle title={taskTitle} /> 
                   <ContainerRowError errorMsg={'Missing parameters!'} />
                </div>
            )
        }

        const imgCateType=task && task.task_param_values?task.task_param_values.imageCateType:''
        const imgUrl=encodeImageUrl(query.imgUrl,query.imgId);
        const noOfImgObjLabel=`Select number of ${imgCateType}s for image segmentation`;
        
        let imgCateDicts=task && task.task_param_values?task.task_param_values.imageCateDicts:[]
        let imgCateDict = null
        if (imgCateDicts.length > 0) {
            imgCateDict = imgCateDicts.filter(item=> item.code == query.imgCateType ).shift()
        }

        return (
            <div className="container">
                <ContainerRowSpace />
                <ContainerRowTitle title={taskTitle} /> 
                <div className='row'>
                    <div className='col-sm'>
                        <div className="ImageBox">
                            <img style={{width: '100%',height: 'auto'}}  src={imgUrl} onClick={()=>imageBoxOnClick(this.props)}  />
                        </div>
                        <Lightbox
                            images={[{ src: imgUrl }]}
                            onClose={()=>closeLightbox(this.props)}
                            isOpen={imgSegment.openLightbox}
                        />
                    </div>
                </div>
                
                <ContainerRowSpace />
                
                <div className='row'>
                    <div className='col-sm'>
                    {imgCateDict?<ImageCateDicts labels={imgCateDict.labels}/>:null}
                    </div>
                </div>

                <div className='row'>
                    <div className='col-sm'>
                       <h3 className="display-7">{`How many ${imgCateType} in this image?`}</h3>
                    </div>
                </div>
                <form onSubmit={handleSubmit} >
                <div className='row'>
                    <div className='col-sm'>
                        <Field
                            label={noOfImgObjLabel}
                            name="answerTotalObjDetected"
                            datas={imgSegment.imgObjNos}
                            component={RFNativeSelectField}
                            codeField={'num'}
                            descField={'num'}
                            customStyle={{width: '380px' }}
                            onChange={this.answerTotalObjDetectedOnChange.bind(this)}       
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-sm'>
                        <Field name="answerImgObjNa" 
                            component={renderCheckbox} 
                            label={`There are no ${imgCateType} in this image`} 
                            onChange={this.answerImgObjNaOnChange.bind(this)} />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-sm'>
                        <Field name="answerImgNotLoad" 
                            component={renderCheckbox} 
                            label="Image does not load" 
                            onChange={this.answerImgNotLoadOnChange.bind(this)} />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-sm'>
                       {renderSubmitButton(this.props,pristine,submitting)}
                    </div>
                </div>
                </form>
            </div>
        )
    }
}

const submit = (values, dispatch, props) => {
    const { imgSegment } = props;
    const query = queryString.parse(props.location.search);
    const jwt = query.jwt;
    const taskAcceptedInfoId = query.taskAcceptedInfoId;

    props.submitResult(jwt,values,taskAcceptedInfoId);
}

const imgSegmentReduxForm = reduxForm({
    form: 'imgSegmentForm', // a unique identifier for this form
    enableReinitialize: true,
    onSubmit: submit
})(ImageSegmentQuestion)

const selector = formValueSelector('imgSegmentForm')

const mapStateToProps = (state, ownProps) => {
    return {
        initialValues: state.imgSegment.imgSegmentForm,
        answerImgNotLoad: selector(state, 'answerImgNotLoad'),
        answerImgObjNa: selector(state, 'answerImgObjNa'),
        answerTotalObjDetected: selector(state, 'answerTotalObjDetected'),
        imgSegment: state.imgSegment
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      updateQuery: (query)=> {
        dispatch(actions.updateQuery(query))
      },    
      getTaskConfig: (jwt,taskAcceptedInfoId) => {
        dispatch(actions.getTaskConfig(jwt,taskAcceptedInfoId))  
      }, 
      openLightBox: () => {
        dispatch(actions.openLightBox())  
      },
      closeLightBox: () => {
        dispatch(actions.closeLightBox())  
      },
      updateAnswer: (imgCateForm) => {
        dispatch(actions.updateAnswer(imgCateForm))  
      },
      submitResult: (jwt,imgSegmentForm,taskAcceptedInfoId) => {
        dispatch(actions.submitResult(jwt,imgSegmentForm,taskAcceptedInfoId))  
      },
      getCurrentSegmentQuestion: (jwt,taskAccessKey) => {
        dispatch(actions.getCurrentSegmentQuestion(jwt,taskAccessKey))  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(imgSegmentReduxForm)


// WEBPACK FOOTER //
// ./src/views/ImageSegmentQuestion/ImageSegmentQuestion.js